import React from 'react';

const Privacidade: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Política de Privacidade</h1>
          <p className="text-green-100">Última atualização: Fevereiro de 2026</p>
        </div>
      </div>

      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="prose prose-green max-w-none">
            <h2>1. Introdução</h2>
            <p>
              A BOILX está comprometida com a proteção da sua privacidade. Esta política explica como coletamos, usamos e protegemos suas informações pessoais.
            </p>

            <h2>2. Dados Coletados</h2>
            <p>Coletamos os seguintes tipos de dados:</p>
            <ul>
              <li><strong>Dados cadastrais:</strong> nome, e-mail, telefone, CPF/CNPJ, endereço</li>
              <li><strong>Dados de uso:</strong> páginas visitadas, anúncios visualizados, buscas realizadas</li>
              <li><strong>Dados técnicos:</strong> endereço IP, tipo de navegador, dispositivo</li>
              <li><strong>Dados de comunicação:</strong> mensagens trocadas na plataforma</li>
            </ul>

            <h2>3. Finalidade do Tratamento</h2>
            <p>Utilizamos seus dados para:</p>
            <ul>
              <li>Criar e gerenciar sua conta</li>
              <li>Processar transações e pagamentos</li>
              <li>Enviar notificações relevantes</li>
              <li>Melhorar nossos serviços</li>
              <li>Prevenir fraudes e garantir segurança</li>
              <li>Cumprir obrigações legais</li>
            </ul>

            <h2>4. Base Legal (LGPD)</h2>
            <p>O tratamento de dados é realizado com base em:</p>
            <ul>
              <li>Consentimento do titular</li>
              <li>Execução de contrato</li>
              <li>Cumprimento de obrigação legal</li>
              <li>Legítimo interesse do controlador</li>
            </ul>

            <h2>5. Compartilhamento de Dados</h2>
            <p>Podemos compartilhar seus dados com:</p>
            <ul>
              <li>Processadores de pagamento (Stripe, PagSeguro)</li>
              <li>Serviços de hospedagem e infraestrutura</li>
              <li>Ferramentas de análise e marketing</li>
              <li>Autoridades quando exigido por lei</li>
            </ul>

            <h2>6. Armazenamento e Segurança</h2>
            <p>
              Seus dados são armazenados em servidores seguros com criptografia. Implementamos medidas técnicas e organizacionais para proteger suas informações contra acesso não autorizado.
            </p>

            <h2>7. Seus Direitos</h2>
            <p>Conforme a LGPD, você tem direito a:</p>
            <ul>
              <li>Confirmar a existência de tratamento</li>
              <li>Acessar seus dados</li>
              <li>Corrigir dados incompletos ou incorretos</li>
              <li>Solicitar anonimização ou exclusão</li>
              <li>Revogar consentimento</li>
              <li>Portabilidade dos dados</li>
            </ul>

            <h2>8. Cookies</h2>
            <p>
              Utilizamos cookies para melhorar sua experiência. Consulte nossa <a href="/cookies">Política de Cookies</a> para mais informações.
            </p>

            <h2>9. Retenção de Dados</h2>
            <p>
              Mantemos seus dados pelo tempo necessário para cumprir as finalidades descritas ou conforme exigido por lei. Dados podem ser mantidos por até 5 anos após o encerramento da conta.
            </p>

            <h2>10. Menores de Idade</h2>
            <p>
              Nossa plataforma não é destinada a menores de 18 anos. Não coletamos conscientemente dados de menores.
            </p>

            <h2>11. Alterações</h2>
            <p>
              Esta política pode ser atualizada periodicamente. Notificaremos sobre mudanças significativas por e-mail ou aviso na plataforma.
            </p>

            <h2>12. Contato do DPO</h2>
            <p>
              Para exercer seus direitos ou esclarecer dúvidas sobre privacidade:<br />
              <strong>E-mail:</strong> <a href="mailto:privacidade@boilx.com.br">privacidade@boilx.com.br</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacidade;
